
import { gql } from '@apollo/client';

export const GET_TAGS = gql`
    query Tags($showPeopleTags: Boolean!, $showCourseTags: Boolean!, $includeAllTags: Boolean) {
    tags(showPeopleTags: $showPeopleTags, showCourseTags: $showCourseTags, includeAllTags: $includeAllTags) {
        id
        name
    }
}`;


export const GET_TAGS_FOR_GROUP = gql`
query TagsForGroup($groupId: Int!) {
    tagsForGroup(groupId: $groupId) {
        id
        name
        code
    }
}`;

/**
 * The same query by group *name*, for callers that know which group they want but not its id.
 *
 * Group ids are per-organisation, so a literal id in a component only ever works in the
 * organisation it was copied from — see the `groupId: 2` that used to sit on /classes/create.
 * Prefer this wherever the group is known in advance; keep `GET_TAGS_FOR_GROUP` for pickers
 * handed an id by the server.
 */
export const GET_TAGS_FOR_GROUP_NAMED = gql`
query TagsForGroupNamed($groupName: String!) {
    tagsForGroup(groupName: $groupName) {
        id
        name
        code
    }
}`;


export const GET_GROUP_BY_GROUP_ID = (listOfFields: string) => gql`
query TagsForGroup($groupId: Int!) {
    getGroup(groupId: $groupId) {
        ${listOfFields}
    }
}`;
